import { ISelectOption } from './selectOption.interface';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { beautifyCamelCaseString } from 'src/app/common/stringUtils';
import { StepType } from '../api/agentStep.model';

const baseStepTypes = [
  StepType.userMessageStep,
  StepType.toolInvocationStep,
  StepType.ragStep,
  StepType.aiMessageStep,
  StepType.triggerStep,
  StepType.memoryStep,
  StepType.agentHandoffRequestStep,
  StepType.agentHandoffResponseStep,
];

// Additional step types for unified pipeline (when dr_unified_pipeline feature flag is enabled)
const unifiedPipelineStepTypes = [StepType.toolResponseStep, StepType.toolRequestStep];

/**
 * Generates step type select options based on whether unified pipeline is enabled
 * @param isUnifiedPipelineEnabled - Whether the unified pipeline feature flag is enabled
 * @returns Array of select options for step types
 */
export function getStepTypeSelectOptions(isUnifiedPipelineEnabled: boolean): ISelectOption[] {
  const stepTypes = isUnifiedPipelineEnabled ? [...baseStepTypes, ...unifiedPipelineStepTypes] : baseStepTypes;

  return stepTypes.sort().map((stepType: StepType) => ({
    id: `${FilterTypesEnum.StepType}-${stepType}`,
    value: stepType,
    displayName: beautifyCamelCaseString(stepType),
    categoryName: FilterTypesEnum.StepType.toString(),
    filterType: FilterTypesEnum.StepType,
    withoutBeautifyDisplayName: true,
  }));
}

// Default export for backward compatibility (uses base step types only)
export const StepTypeSelectOptions: ISelectOption[] = getStepTypeSelectOptions(false);
